import { ComponentBase, component } from "@sygnal/sse-core";
import { gsap } from "gsap";

@component('nav_menu-button')
export class NavMenuComponent extends ComponentBase {
  private isOpen = false;
  private tl!: gsap.core.Timeline;
  private button!: HTMLElement;

  protected async onLoad(): Promise<void> {
    const button = document.querySelector<HTMLElement>(".nav_menu-button");
    const navLines = document.querySelectorAll<HTMLElement>(".nav_line");
    const mobileMenu = document.querySelector<HTMLElement>(".nav_menu_mobile");

    if (!button || navLines.length < 2 || !mobileMenu) {
      console.warn("Nav elements not found. Check your selectors.");
      return;
    }

    this.button = button;

    const [lineTop, lineBottom] = Array.from(navLines);

    gsap.set(mobileMenu, { display: "flex", autoAlpha: 0, y: -12 });

    this.tl = gsap.timeline({ paused: true, defaults: { ease: "power2.inOut" } });

    this.tl
      .to(lineTop, { y: 7, rotate: 45, duration: 0.35 }, 0)
      .to(lineBottom, { y: -7, rotate: -45, duration: 0.35 }, 0)
      .to(mobileMenu, { autoAlpha: 1, y: 0, duration: 0.4, ease: "power3.out" }, 0.15);

    button.addEventListener("click", this.handleClick.bind(this));
  }

  private handleClick(): void {
    if (!this.tl) return;
    this.isOpen = !this.isOpen;
    this.button.setAttribute("aria-expanded", String(this.isOpen));
    this.isOpen ? this.tl.play() : this.tl.reverse();
  }
}
